<kendo-panelbar>
  <kendo-panelbar-item  title="Patient Forms" [expanded]="false">
    <ng-template kendoPanelBarContent>
      <div [style.padding.px]="10" class="legend example-config">
        <span class="legend-item">
          <span class="legend-color" [style.backgroundColor]="'#ffcdd2'"></span>
          POLST
        </span>
        <span class="legend-item">
          <span class="legend-color" [style.backgroundColor]="'#ADD8E6'"></span>
          AD
        </span>
      </div>
      <div [style.padding.px]="10">
        <kendo-grid [kendoGridBinding]="gridData" [pageSize]="10" [pageable]="true">
          <kendo-grid-column field="Type" [width]="50">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="ProcessFormsUtil.getFormColumnColor(dataItem)">
                {{dataItem.type | formType}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Current" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="ProcessFormsUtil.getFormColumnColor(dataItem)">
                @if (dataItem.current) {
                  <div>Yes</div>
                }
                @if (!dataItem.current) {
                  <div style="color: #d9534f"><b>No</b></div>
                }
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Document Date" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="ProcessFormsUtil.getFormColumnColor(dataItem)">
                @if (dataItem.type !== 'POLST') {
                  <div>{{dataItem.doc_date | convertUtcNoTime}}</div>
                }
                @if (dataItem.type === 'POLST') {
                  <div>{{dataItem.created | convertUtcNoTime}}</div>
                }
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="View" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton>View</button>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>
